import { render } from "./BuyPanel.vue?vue&type=template&id=f5e8e5da&scoped=true&ts=true"
import script from "./BuyPanel.vue?vue&type=script&lang=ts"
export * from "./BuyPanel.vue?vue&type=script&lang=ts"

import "./BuyPanel.vue?vue&type=style&index=0&id=f5e8e5da&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5e8e5da"]])

export default __exports__